import { observer } from "mobx-react";
import Selfie from "./index.js";


const SelfieLiveness = observer(() => {
    return <Selfie processType="liveness" />;
})


export default SelfieLiveness;